import { render, staticRenderFns } from "./ViewMaterialsTransferred.vue?vue&type=template&id=f99899cc&scoped=true"
import script from "./ViewMaterialsTransferred.vue?vue&type=script&lang=js"
export * from "./ViewMaterialsTransferred.vue?vue&type=script&lang=js"
import style0 from "./ViewMaterialsTransferred.vue?vue&type=style&index=0&id=f99899cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99899cc",
  null
  
)

export default component.exports